import { forwardRef } from "react";
import { cn } from "@/utils/cn";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "outline";
  className?: string;
  children: React.ReactNode;
}

const variants = {
  primary:
    "inline-flex min-h-[44px] items-center justify-center rounded-md bg-healthsource-red px-4 py-2 text-sm font-semibold text-white hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-healthsource-red focus-visible:ring-offset-2 disabled:opacity-50 font-nunito",
  outline:
    "inline-flex min-h-[44px] items-center justify-center rounded-md border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 font-nunito",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", className, children, ...props }, ref) => (
    <button
      ref={ref}
      type={props.type ?? "button"}
      className={cn(variants[variant], className)}
      {...props}
    >
      {children}
    </button>
  )
);
Button.displayName = "Button";
